import React, { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import infoIcon from "../../assets/images/info.png";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {NavLink} from "react-router-dom";
import Button from "react-bootstrap/Button";
import {motion, AnimatePresence} from "framer-motion";
import classes from "../GameDetails/GameDetails.module.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Accordion from 'react-bootstrap/Accordion';
import {AccordionCollapse, AccordionToggle} from "react-bootstrap";
import {formatParagraphs} from "../../utils/utils";
import ReactHtmlParser from "react-html-parser";


export default function ImplementedPattern({implemented_pattern, patternSelected, gameName}) {
    // const history = useHistory();

    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    }



    const example_descriptions =
        implemented_pattern.example_descriptions.map((example_description, index) => {
            const primary_title_popover = <div style={{position: "absolute", top: 0, right: "2.5%", }}>
                {example_description.primary_game_title ? (
                    <OverlayTrigger
                        trigger="click"
                        rootClose
                        rootCloseEvent="click"
                        placement='bottom'
                        overlay={<Popover id='pattern-game-description'>
                            <Popover.Content className="implemented-game-note">
                                Using the same implementation as described for {example_description.primary_game_title}.
                            </Popover.Content>
                        </Popover>}
                    >
                        <img className="info-icon" src={infoIcon} alt="Info"/>
                    </OverlayTrigger>
                ) : ""}</div>;


            return (<Row key={'example-description-' + implemented_pattern.pattern_id + "-" + index}>
                <Col sm={12}>
                    <dl className="row">
                        <dt className="col-xl-2">Example Description:</dt>
                        <dd className="col-xl-10">
                            <div style={{
                                display: "flex",
                                alignItems: "center" // vertically align both elements if necessary
                            }}>
                                <div style={{
                                    width: "90%",
                                    
                                }}>
                                    {formatParagraphs(example_description.description_text)}
                                </div>
                                <div>{primary_title_popover}</div>
                            </div>
                        </dd>
                    </dl>
                </Col>
            </Row>)
        })

    const optional_dash = implemented_pattern.pattern_descriptive_title ?
        (<span style={{padding: "8px"}}>&mdash;</span>) : "";


    return (
        <Accordion defaultActiveKey="1">
            <div className="card" style={{border: "2px solid #808080", margin: "5px", }}>
                <AccordionToggle className={classes.accordionHeader} eventKey="0" style={{ textAlign: "left" }} onClick={handleToggle}>
                    <div className={classes.patternName} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ flexGrow: 1 }}>
                            <b>{implemented_pattern.pattern_name}</b>{optional_dash}
                            <span style={{ paddingBottom: "2px", marginLeft: "8px" }}>
                {implemented_pattern.pattern_descriptive_title}
            </span>
                        </div>
                        <AnimatePresence>
                            <motion.div animate={{
                                rotate: isOpen ? 180 : 0,
                            }}>
                                <ExpandMoreIcon />
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </AccordionToggle>
                <AccordionCollapse eventKey="0">
                    <div className="card-body" style={{borderTop: "2px solid #808080"}}>
                        <Row>
                            <Col sm={12}>
                                <dl className="row">
                                    <dt className="col-xl-2">Design Problem:</dt>
                                    <dd className="col-xl-10">
                                        <div style={{display: "flex", alignItems: "center"}}>
                                        <div style={{width: "90%", }}>
                                            {/*Old pre-TinyMCE display function. Keeping until the new code had proven out*/}
                                            {/*{formatParagraphs(implemented_pattern.pattern_design_problem, 8, '4ch')}*/}
                                            {ReactHtmlParser(implemented_pattern.pattern_design_problem)}
                                        </div>
                                            <div style={{position: "absolute", top: 0, right: "2.5%", }}>{implemented_pattern.design_problem_count > 1 && (
                                                <OverlayTrigger
                                                    trigger="click"
                                                    rootClose
                                                    rootCloseEvent="click"
                                                    placement="bottom"
                                                    overlay={
                                                        <Popover id="pattern-game-description">
                                                            <Popover.Content className="implemented-game-note" style={{textAlign: "center"}}>
                                                                This pattern solves additional Design Problems,<br/>
                                                                <b>View Pattern Details</b> to see all of them.
                                                            </Popover.Content>
                                                        </Popover>
                                                    }
                                                >
                                                    <img className="info-icon" src={infoIcon} alt="Info"/>
                                                </OverlayTrigger>
                                            )}</div>
                                        </div>
                                    </dd>
                                </dl>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <dl className="row">
                                    <dt className="col-xl-2">Pattern Description:</dt>
                                    <dd className="col-xl-10">
                                        <div style={{width: "90%", }}>
                                            {/*Old pre-TinyMCE display function. Keeping until the new code had proven out*/}
                                            {/*{formatParagraphs(implemented_pattern.pattern_description, 8, '4ch')}*/}
                                            {ReactHtmlParser(implemented_pattern.pattern_description)}
                                        </div>
                                    </dd>
                                </dl>
                            </Col>
                        </Row>
                        {example_descriptions}
                        <div style={{textAlign: "right"}}>
                            <NavLink
                                to={'/PatternLibraryApp/PatternLibrary/' + implemented_pattern.pattern_id}
                                exact
                            >
                                <Button variant="outline-primary">View Pattern Details</Button>
                            </NavLink>
                            {/*<Button variant="outline-primary" onClick={() => {*/}
                            {/*    if (history.location.pathname !== '/PatternLibraryApp/PatternLibrary/' + implemented_pattern.pattern_id) {*/}
                            {/*        console.log('push ip', history.location.pathname, '/PatternLibraryApp/PatternLibrary/' + implemented_pattern.pattern_id)*/}
                            {/*        history.push('/PatternLibraryApp/PatternLibrary/' + implemented_pattern.pattern_id);*/}
                            {/*    }*/}

                            {/*    //patternSelected(implemented_pattern.pattern_id);*/}
                            {/*}}>*/}
                            {/*    View Pattern Details*/}
                            {/*</Button>*/}
                        </div>
                    </div>
                </AccordionCollapse>
            </div>
        </Accordion>
    );

    // return (
    //     <div>
    //         <Accordion defaultActiveKey="1">
    //                      <div className="card" style={{borderColor: "#808080"}}>
    //                          <AccordionToggle className={classes.accordionHeader} eventKey="0">
    //                              <div className={classes.patternName}>
    //                                  <Col>
    //                                      <Row>
    //                                          {implemented_pattern.pattern_name}
    //                                     </Row>
    //                                      <Row className={classes.descriptiveTitle}>
    //                                          {implemented_pattern.pattern_descriptive_title ?
    //                                             implemented_pattern.pattern_descriptive_title : ''}
    //                                     </Row>
    //                                 </Col>
    //                             </div>
    //                         </AccordionToggle>
    //                         <AccordionCollapse eventKey="0">
    //                             <div className="card-body" style={{borderTop: "1px solid #979797"}}>
    //                                 Design Problem: {implemented_pattern.pattern_design_problem}<br/><br/>
    //                                 Pattern Description: {implemented_pattern.pattern_description}<br/><br/>
    //                                 Implementation in {gameName}: {implemented_pattern.example_descriptions[0].description_text} —
    //                                 <span className="view-game-link" onClick={() => {
    //                                     history.replace('/PatternLibraryApp/PatternLibrary');
    //                                     patternSelected(implemented_pattern.pattern_id);
    //                                 }}>
    //                                                 View Pattern Details
    //                                             </span>
    //                             </div>
    //                         </AccordionCollapse>
    //                     </div>
    //                 </Accordion>
    //     <div className={classes.dlTitle}>
    //     <div>
    //         <div className={classes.patternName}>
    //             <Col>
    //                 <Row>
    //                     {implemented_pattern.pattern_name}
    //                 </Row>
    //                 <Row className={classes.descriptiveTitle}>
    //                     {implemented_pattern.pattern_descriptive_title ?
    //                         implemented_pattern.pattern_descriptive_title : ''}
    //                 </Row>
    //             </Col>
    //             <OverlayTrigger
    //                 trigger="click"
    //                 rootClose
    //                 rootCloseEvent="click"
    //                 placement='bottom'
    //                 overlay={<Popover id='pattern-game-description'>
    //                     <Popover.Title as="h3">{implemented_pattern.pattern_name}</Popover.Title>
    //                     <Popover.Content className="game-description">
    //                         Design Problem: {implemented_pattern.pattern_design_problem}<br/><br/>
    //                         Pattern Description: {implemented_pattern.pattern_description}<br/><br/>
    //                         Implementation in {gameName}: {implemented_pattern.example_descriptions[0].description_text} —
    //                         <span className="view-game-link" onClick={() => {
    //                             history.replace('/PatternLibraryApp/PatternLibrary');
    //                             patternSelected(implemented_pattern.pattern_id);
    //                         }}>
    //                             View Pattern Details
    //                         </span>
    //                     </Popover.Content>
    //                 </Popover>}
    //             >
    //                 <img className="info-icon" src={infoIcon} alt="Info"/>
    //             </OverlayTrigger>
    //         </div>
    //     </div>
    //     </div></div>);
}
